const VALID_PASSWORD_MIN_LENGTH = 8

const isValidPassword = (password) =>
  password.length >= VALID_PASSWORD_MIN_LENGTH &&
  /^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*)$/.test(password)

export default isValidPassword
